import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  ReferralAdminRow,
  ReferralLeaderboardRow,
  ReferralProgramStats,
  UserReferralStats,
} from '@chiroup/core/types/Referral.type';

export type ReferralOverviewResponse = {
  stats: ReferralProgramStats;
  leaderboard: ReferralLeaderboardRow[];
  referrals: ReferralAdminRow[];
};

const referralService = () => {
  const overview = async (
    startDate?: string,
    endDate?: string
  ): Promise<ReferralOverviewResponse> => {
    return ChiroUpAPI.get('api', '/referrals/overview', {
      queryParams: {
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
      },
    });
  };

  const userReferrals = async (userId: string): Promise<UserReferralStats> => {
    return ChiroUpAPI.get('api', `/users/${userId}/referrals`, {});
  };

  return { overview, userReferrals };
};

export default referralService();
